//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import onClickOutside from '~/directives/click-outside'

export default {
  name: 'AppHeaderMastheadNav',

  directives: {
    clickOutside: onClickOutside
  },

  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters('user', [
      'isPending',
      'isUser',
      'isSubscriber',
      'isCanceled'
    ]),

    navItems() {
      return [
        {
          show: this.isSubscriber,
          title: 'My Account',
          href: '/my_account'
        },
        {
          show: this.isSubscriber && !this.isPending,
          title: 'Report & Tips',
          href: '/my_account/nutrition-report'
        },
        {
          show: this.isSubscriber,
          title: 'My Routine',
          href: '/my_account/routine'
        },
        {
          show: this.isSubscriber,
          title: 'Orders & Tracking',
          href: '/my_account/order-history'
        },
        {
          show: this.isSubscriber && !this.isCanceled,
          title: 'My Info & Shipping',
          href: '/my_account/customer'
        },
        {
          show: this.isSubscriber && !this.isCanceled,
          title: 'My Membership',
          href: '/my_account/membership'
        },
        {
          show: this.isUser && !this.isSubscriber,
          title: 'Recommendations',
          href: '/recommendations'
        },
        {
          show: this.isUser,
          title: 'Log Out',
          href: '/logout',
          external: true
        }
      ]
    }
  },

  watch: {
    $route() {
      this.dismiss()
    }
  },

  methods: {
    dismiss() {
      this.$emit('close')
    }
  }
}
